import React from 'react';
import styles from './CardHeader.module.sass';

const CardHeader = ({
    children, actions,
    position
}: Props) => {
    
    return <div className={`${styles['cardheader']} ${styles['cardheader__position--'+(position??'static')]}`}>
        { children }
        { actions }
    </div>;
}

interface Props {
    children: any
    actions?: any
    position?: 'sticky' | 'static'
}

export default CardHeader;